import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../styles/App.css";
import "@amzn/meridian";
import zoomSdk from "@zoom/appssdk";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Summaries from "./inMeeting/././summary/Summaries";
import SummaryDetail from "./inMeeting/././summary/SummaryDetails";
import SummaryDetailInClient from "./inMainClient/./summaryTab/SummaryDetailInClient";
import MainClientHome from "./inMainClient/MainClientHome";
import SummariesTabInClient from "./inMainClient/./summaryTab/SummariesTabInClient";
import LogManager from "./utils/LogManager";

const App = () => {
  const [lastKnownContext, setLastKnownContext] = useState(null);

  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (window.location.pathname.startsWith("/client") && document.visibilityState === 'visible' && lastKnownContext === "inMainClient") {
        LogManager.info('App became visible on client route, checking context...');
        try {
          const newContext = await zoomSdk.getRunningContext();
          LogManager.info(`Current SDK context: ${newContext.context}, Last known context: ${lastKnownContext}`);
          
          if (newContext.context !== lastKnownContext) {
            LogManager.info(`Context changed from ${lastKnownContext} to ${newContext.context}`);
            if (newContext.context === "inMeeting") {
              window.location.href = `${window.location.origin}/`;
            }
          }
          setLastKnownContext(newContext.context);
        } catch (error) {
          LogManager.error('Error checking context:', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [lastKnownContext]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/meeting/summary" element={<Summaries />} />
        <Route path="/meeting/summary/:id" element={<SummaryDetail />} />
        <Route path="/client" element={<MainClientHome />} />
        <Route path="/client/summary/:id" element={<SummaryDetailInClient />} />
        <Route path="*" element={<Home lastKnownContext={lastKnownContext} setLastKnownContext={setLastKnownContext} />} />
      </Routes>
    </Router>
  );
};

export default App;
